import {
  fireDataLayerEvent,
  updateAndSyncDatalayer,
} from '../tag-commander/datalayer';

export const createDatalayerTrackingClient = (_params?) => {
  return {
    trackEvent: fireDataLayerEvent,
    save: updateAndSyncDatalayer,
  };
};
